var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      staticClass: "no-bg-hover",
      attrs: {
        width: _vm.btnSize,
        height: _vm.btnSize,
        depressed: "",
        ripple: false,
        icon: "",
      },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.onFavourite.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-icon",
        {
          staticStyle: { stroke: "white" },
          attrs: { size: _vm.size, color: _vm.color },
        },
        [_vm._v(" " + _vm._s(_vm.mdiHeart) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }